export function calculateMaximumMortgage(salary, partnerSalary) {
  const parsedSalary = parseInt(salary) || 0;
  const parsedPartnerSalary = parseInt(partnerSalary) || 0;

  const maximumMortgage = (parsedSalary + parsedPartnerSalary) * 5;

  return maximumMortgage;
}

